<template>
    <div v-if="modaleChoixLangueOuverte" class="mainContainer-langue-nav" @click="ouvrirFermerModaleChoixLangue" />
    <div v-if="this.showMyAccountMenu" class="mainContainer-nav" @click="closeNav"></div>
    <header class="en-tete">
        <div class="bandeau">
            <div v-if="connected" class="container-title-icon">
                <img :alt="$t('alt.logo.entreprise')" :src="loadIcon" class="icon-portail" />
                <div class="partner">
                    <img
                        v-for="logo in logos"
                        :key="logo.id"
                        :alt="$t('alt.partenaire', { nom: logo.id })"
                        :src="logo.src"
                        class="icon"
                    />
                </div>
            </div>
            <div class="container-menu-account">
                <BorderedIconButton
                    v-if="connected && envActuel && envActuel.toUpperCase() !== 'PROD'"
                    id="bouton-app-info"
                    :className="'header-button'"
                    :imgUrl="loadIconAppInfo"
                    :onClick="openAppInfoModale"
                    :title="envActuel"
                    class="bandeau-button"
                />
                <button
                    v-if="connected && autoriseReglesGestion"
                    id="bouton-regles-gestion"
                    :aria-pressed="reglesGestionActif"
                    class="regles-gestion-toggle"
                    type="button"
                    @click="basculerReglesGestion"
                >
                    <img :alt="''" :src="loadIconReglesGestion" class="regles-gestion-toggle__icone" />
                    <span>Règles de gestion</span>
                </button>
                <span v-if="connected && isPortailClient" class="bouton-avec-regle">
                    <BorderedIconButton
                        id="bouton-demande-devis"
                        :className="'header-button'"
                        :imgUrl="loadIconDevis"
                        :onClick="goDevis"
                        :title="$t('header.estimate.request.button')"
                        class="bandeau-button"
                    />
                    <ReglePastille cle="menuCompte.boutonDemanderDevis" />
                </span>
                <span v-if="connected && checkDroitSubRoute('creer.demande') && isPortailClient" class="bouton-avec-regle">
                    <BorderedIconButton
                        id="bouton-demande-intervention"
                        :className="'header-button'"
                        :imgUrl="loadIconIntervention"
                        :onClick="goIntervention"
                        :title="$t('header.intervention.request.button')"
                        class="bandeau-button"
                    />
                    <ReglePastille cle="menuCompte.boutonDemandeIntervention" />
                </span>
                <button
                    v-if="connected"
                    id="bouton-mon-compte"
                    :aria-expanded="showMyAccountMenu"
                    :aria-label="$t('modale.my.account.title')"
                    aria-haspopup="true"
                    class="container-my-account"
                    @click="openNav"
                >
                    <RoundedIconAndText />
                    <div v-show="showMyAccountMenu" class="container-dropdown">
                        <div class="content-dropdown">
                            <span class="login-user">{{ login }}</span>
                            <button class="dropdown-button disconnect" @click.stop="disconnect">
                                {{ $t('app.disconnect') }}
                                <ReglePastille cle="menuCompte.deconnexion" placement="bottom" />
                            </button>
                            <button
                                v-if="isClient"
                                class="dropdown-button options"
                                @click.stop="openOptionsSuiviModale"
                            >
                                {{ $t('modale.options.suivi.di.open') }}
                                <ReglePastille cle="menuCompte.optionsInterventions" placement="bottom" />
                            </button>
                            <button
                                v-if="isClient"
                                class="dropdown-button options"
                                @click.stop="openPreavisInterventionModale"
                            >
                               {{ $t('modale.preavisIntervention.open') }}
                               <ReglePastille cle="menuCompte.preavisIntervention" placement="bottom" />
                            </button>

                            <button class="dropdown-button options" @click.stop="openMonCompteModale">
                                {{ $t('modale.my.account.title') }}
                                <ReglePastille cle="menuCompte.monCompte" placement="bottom" />
                            </button>
                        </div>
                    </div>
                </button>
                <img
                    v-if="connected"
                    :alt="$t('alt.drapeau.langue')"
                    :src="getImageDrapeauLangueSelectionnee"
                    class="height-20px margin-left-10px"
                />
                <button
                    v-if="connected"
                    :aria-expanded="modaleChoixLangueOuverte"
                    :aria-label="$t('aria.modale.choix.langue')"
                    aria-haspopup="true"
                    class="language-button"
                    @click="ouvrirFermerModaleChoixLangue"
                >
                    <img v-if="!modaleChoixLangueOuverte" :alt="$t('alt.ouverture.menu.langues')" :src="getArrowDown" />
                    <img v-else :alt="$t('alt.fermeture.menu.langues')" :src="getArrowUp" />
                </button>
                <div v-if="modaleChoixLangueOuverte" class="language-flags-container">
                    <button
                        v-for="langue in getLanguesdisponibles"
                        :key="langue"
                        class="cursor-pointer language-item"
                        @click="setLangue(langue.id)"
                    >
                        {{ langue.langue }}
                        <span class="float-right">
                            <img
                                :alt="$t('alt.changer.langue', { langue: langue.langue })"
                                :src="getImageDrapeauLangue(langue.id)"
                                class="height-20px width-30px margin-top-0 margin-10px language-flag"
                            />
                        </span>
                    </button>
                </div>
            </div>
        </div>
        <OptionSuiviModale v-if="isModaleOptionsSuiviOpen" />
        <PreavisInterventionModale v-if="isModalePreavisOpen" />
        <MonCompteModale v-if="isModaleMonCompteOpen" />
        <AppInfoModale v-if="isModaleAppInfoOpen" @cancel="closeAppInfoModale" />
    </header>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import RoundedIconAndText from '@/components/ui-components/RoundedIconAndText.vue';
import BorderedIconButton from '@/components/ui-components/BorderedIconButton.vue';
import { AccountAction } from '@/modules/Account/store/actions-types';
import { AUTH } from '@/modules/Auth/store/mutation-types';
import { DEMANDE_DEVIS } from '@/modules/DemandeDevis/store/mutation-types';
import { DEMANDE_INTERVENTION } from '@/modules/DemandeIntervention/store/mutation-types';
import { DEVIS } from '@/modules/Devis/store/mutation-types';
import { SUIVI_INTERVENTION } from '@/modules/SuiviInterventions/store/mutation-types';
import { HomeAction } from '@/modules/Home/store/actions-types';
import { INTERVENTION } from '@/modules/Intervention/store/mutation-types';
import { SUIVI_FACTURES } from '@/modules/SuiviFactures/store/mutation-types';
import { PREVENTIF } from '@/modules/Preventif/store/mutation-types';
import { SUIVI_RECLAMATION } from '@/modules/SuiviReclamation/store/mutation-types';
import { DOCUMENT_REGLEMENTAIRE } from '@/modules/DocumentReglementaire/store/mutation-types';
import { OPTIONS_SUIVI } from '@/modules/OptionsSuiviInterventions/store/mutation-types';
import OptionSuiviModale from '@/modules/OptionsSuiviInterventions/components/OptionSuiviModale.vue';
import { store } from '@/plugins/store';
import { MON_COMPTE } from '@/modules/MonCompte/store/mutation-types';
import { SITE_LIST } from '@/modules/SiteList/store/mutation-types';
import { ACCOUNT } from '@/modules/Account/store/mutation-types';
import { HOME } from '@/modules/Home/store/mutation-types';
import MonCompteModale from '@/modules/MonCompte/components/MonCompteModale.vue';
import PreavisInterventionModale from '@/modules/PreavisIntervention/pages/PreavisInterventionModale.vue';
import { PREAVIS } from '@/modules/PreavisIntervention/store/mutation-types';
import { msalInstance } from '@/authenticationConfig';
import { useMsal } from '@/common/utils/useMsal';
import { Langue } from '@/modules/Home/store/state';
import AppInfoModale from '@/modules/AppInfo/components/AppInfoModale.vue';
import { REGLES_GESTION as ReglesGestionMutations } from '@/modules/ReglesGestion/store/mutation-types';
import ReglePastille from '@/components/regles/ReglePastille.vue';

export default defineComponent({
    name: 'MainHeader',
    props: {
        connected: {
            type: Boolean,
        },
    },
    components: {
        MonCompteModale,
        RoundedIconAndText,
        BorderedIconButton,
        ReglePastille,
        OptionSuiviModale,
        PreavisInterventionModale,
        AppInfoModale,
    },
    computed: {
        loadIconIntervention() {
            return require('@/assets/img/menu/outils.png');
        },
        loadIconAppInfo() {
            return require('@/assets/img/info_24dp.png');
        },
        loadIconReglesGestion(): string {
            return this.reglesGestionActif
                ? require('@/assets/img/toggle-on.svg')
                : require('@/assets/img/toggle-off.svg');
        },
        reglesGestionActif(): boolean {
            return this.$store.getters['reglesGestionState/isActif'];
        },
        envActuel(): string {
            return window.CONFIG?.env || '';
        },
        envAutoriseReglesGestion(): boolean {
            return ['DEV', 'INT', 'REC'].includes(this.envActuel.toUpperCase());
        },
        autoriseReglesGestion(): boolean {
            return (
                this.envAutoriseReglesGestion &&
                !!store.getters.getUserInformations?.fonctions.includes('acces.reglesmetier')
            );
        },
        envCouleur(): string {
            switch (window.CONFIG?.env) {
                case 'DEV':
                    return 'var(--env-dev)';
                case 'INT':
                    return 'var(--env-int)';
                case 'REC':
                    return 'var(--env-rec)';
                default:
                    return 'transparent';
            }
        },
        loadIconDevis() {
            return require('@/assets/img/menu/calculate.png');
        },
        loadIcon() {
            return require('@/assets/img/logo.svg');
        },
        isModaleOptionsSuiviOpen() {
            return store.state.optionsSuiviInterventionState.isModaleOpen;
        },
        isModaleMonCompteOpen() {
            return store.state.monCompteState.isModaleOpen;
        },
        isModalePreavisOpen() {
            return store.state.preavisInterventionState.isModaleOpen;
        },
        login() {
            return localStorage.getItem('login');
        },
        isPortailClient(): boolean {
            return this.$router.currentRoute.value.meta.droit !== 'role.fournisseur';
        },
        isClient(): boolean {
            return localStorage.getItem('isClient') === 'true';
        },
        getImageDrapeauLangueSelectionnee(): string {
            const langueSelectionnee = this.$store.getters.getLangueSelectionnee;
            if (langueSelectionnee != null) {
                return this.getImageDrapeauLangue(langueSelectionnee.id);
            }
            return '';
        },
        getLanguesdisponibles(): Langue[] {
            return this.$store.getters.getLanguesDisponibles;
        },
        getArrowDown() {
            return require('@/assets/img/arrow_drop_down.png');
        },
        getArrowUp() {
            return require('@/assets/img/arrow_drop_up_24.png');
        },
    },
    data() {
        const instance = useMsal();
        return {
            showMyAccountMenu: false,
            instance: instance,
            logos: [] as { id: number; src: string }[],
            logosInexistant: [14, 23, 33, 57, 10, 80, 40, 31, 54, 58, 38] as number[],
            modaleChoixLangueOuverte: false,
            isModaleAppInfoOpen: false,
        };
    },
    async mounted() {
        if (this.connected) {
            this.$store.dispatch(AccountAction.GET_SOCIETES, true).then(() => {
                // il n'y a pas de logo de Henelia (23), Financière Hervé (33), Cel (57), STES CIVILES IMMOBILIERES(10), CONSORTIUM SUISSE(80), ENTREPRISE SMC(40)
                // Billon(14) a fusionné avec Hervé Thermique
                // Mantis 47798 : Retirer logos effet d'o (31), herve belgium (54) et groupe solyos (58)
                this.logos = this.$store.getters.getSocieteIds
                    .filter((id: number) => !this.logosInexistant.includes(id))
                    .map((id: number) => {
                        return {
                            id: id,
                            src: window.CONFIG.logosUrl + id + '.png',
                        };
                    });
            });
        }
        await this.getLangues();
        this.getLangueSelectionnee();
        this.getTraductions();
    },
    methods: {
        openAppInfoModale() {
            this.isModaleAppInfoOpen = true;
        },
        basculerReglesGestion() {
            const actif = this.$store.getters['reglesGestionState/isActif'];
            this.$store.commit(`reglesGestionState/${ReglesGestionMutations.SET_ACTIF}`, !actif);
        },
        closeAppInfoModale() {
            this.isModaleAppInfoOpen = false;
        },
        goIntervention() {
            this.$router.push('/intervention');
        },
        goDevis() {
            this.$router.push('/devis');
        },
        async disconnect() {
            if (localStorage.getItem('botActive') === 'true') {
                window['ideta_bot_action']('remove');
            }
            this.$store.commit(`suiviDemandeInterventionModuleState/${DEMANDE_INTERVENTION.CLEAR_ALL}`);
            this.$store.commit(`suiviInterventionModuleState/${SUIVI_INTERVENTION.CLEAR_ALL}`);
            this.$store.commit(DEMANDE_DEVIS.CLEAR_ALL);
            this.$store.commit(DEVIS.CLEAR_ALL);
            this.$store.commit(AUTH.CLEAR_TOKEN);
            this.$store.commit(INTERVENTION.CLEAR_ALL);
            this.$store.commit(`suiviFacturesModuleState/${SUIVI_FACTURES.CLEAR_ALL}`);
            this.$store.commit(`siteList/${SITE_LIST.RESET}`);
            this.$store.commit(`accountModule/${ACCOUNT.RESET}`);
            this.$store.commit(`homeState/${HOME.RESET}`);
            this.$store.commit(PREVENTIF.RESET);
            this.$store.commit(SUIVI_RECLAMATION.RESET);
            this.$store.commit(`documentReglementaireState/${DOCUMENT_REGLEMENTAIRE.RESET}`);
            this.$store.commit(`optionsSuiviInterventionState/${OPTIONS_SUIVI.RESET}`);
            this.$store.commit(`monCompteState/${MON_COMPTE.RESET}`);
            this.$store.commit(`preavisInterventionState/${PREAVIS.RESET}`);
            this.$store.dispatch(HomeAction.RESET_MODULES);
            localStorage.removeItem('token_portail_partenaire');
            localStorage.removeItem('token_azure');
            localStorage.removeItem('token');
            localStorage.removeItem('login');
            localStorage.removeItem('redirectAfterLogin');
            localStorage.removeItem('nom');
            localStorage.removeItem('tokenAzure');
            localStorage.removeItem('prenom');
            localStorage.removeItem('email');
            localStorage.setItem('botActive', 'false');
            await msalInstance.clearCache();
            await msalInstance.setActiveAccount(null);
            await msalInstance.handleRedirectPromise().catch(error => {
                console.error(error);
            });
            // On se déconnecte d'Azure
            const logoutRequest = {
                account: msalInstance.getActiveAccount(),
            };

            localStorage.removeItem('redirectAfterLogin');

            // On redirige vers la page d'authentification
            console.info('[MenuPage] logoutRedirect');
            await this.instance.logoutRedirect(logoutRequest);
            localStorage.removeItem('token_portail_partenaire');
            localStorage.removeItem('token');
            this.$router.replace('/');
        },
        openOptionsSuiviModale() {
            this.$store.commit(`optionsSuiviInterventionState/${OPTIONS_SUIVI.SET_MODAL}`, true);
        },
        openMonCompteModale() {
            this.$store.commit(`monCompteState/${MON_COMPTE.SET_MODAL}`, true);
        },
        openPreavisInterventionModale() {
            this.$store.commit(`preavisInterventionState/${PREAVIS.SET_MODAL}`, true);
        },
        openNav() {
            this.showMyAccountMenu = true;
        },
        closeNav() {
            this.showMyAccountMenu = false;
        },
        checkDroitSubRoute(droit: string): boolean {
            return store.getters.getUserInformations?.fonctions.includes(droit);
        },
        ouvrirFermerModaleChoixLangue() {
            this.modaleChoixLangueOuverte = !this.modaleChoixLangueOuverte;
        },
        getImageDrapeauLangue(langueId: number): string {
            return require('@/assets/img/drapeaux/' + langueId + '.png');
        },
        async setLangue(langueId: number) {
            await this.$store.dispatch(HomeAction.SET_LANGUE, langueId);
            this.ouvrirFermerModaleChoixLangue();
            await this.$store.dispatch(HomeAction.GET_TRADUCTIONS);
            this.$router.go(0);
        },
        async getLangues(): Promise<void> {
            await this.$store.dispatch(HomeAction.GET_LANGUES);
        },
        getLangueSelectionnee(): void {
            this.$store.dispatch(HomeAction.GET_LANGUE_SELECTIONNEE);
        },
        getTraductions(): void {
            this.$store.dispatch(HomeAction.GET_TRADUCTIONS);
        },
    },
});
</script>

<style scoped>
.en-tete {
    height: 60px;
    background-color: var(--background-principal);
    display: flex;
    flex-direction: column;
    justify-content: space-around;
}
.bandeau-button {
    background-color: var(--bleu-secondaire);
    margin-right: 25px;
    height: 38px;
}
.bandeau {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 10px;
}
.container-title-icon {
    display: flex;
    align-items: center;
}
.container-my-account {
    display: flex;
    align-items: center;
    cursor: pointer;
    background-color: var(--bleu-secondaire);
    border-radius: 20px;
    height: 40px;
    width: 40px;
    justify-content: center;
    padding: 0;
    margin: 0;
    border: none;
    font-family: inherit;
    position: relative;
}
.language-button {
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    display: flex;
    align-items: center;
}
.container-my-account:focus-visible {
    outline: 2px solid var(--color-principal);
    outline-offset: 2px;
}
.language-button:focus-visible {
    outline: 2px solid var(--color-principal);
    outline-offset: 2px;
}
.language-item:focus-visible {
    background-color: var(--medium-grey);
    outline: none;
}
.language-item {
    border: none;
    background: none;
    font-family: Raleway, sans-serif;
    font-variant-numeric: lining-nums;
    font-size: var(--font-size-low-medium);
}
.container-menu-account {
    display: flex;
    align-items: center;
}
.container-title {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 20px;
    color: var(--bleu-prinicipal);
}
.nom-portail {
    margin: 0;
    font-family: 'Raleway Bold', sans-serif;
    font-variant-numeric: lining-nums;
    font-size: var(--font-size-high-medium);
    color: var(--color-principal);
    font-weight: 900;
}
.subtitle-portail {
    margin: 0;
    font-family: 'Raleway', sans-serif;
    font-variant-numeric: lining-nums;
    font-style: normal;
    font-size: var(--font-size-medium);
    line-height: 20px;
    font-weight: 400;
    color: var(--color-principal);
    font-feature-settings: 'pnum' on, 'lnum' on;
}
.icon-portail {
    height: 40px;
    border: 1px solid #b8b8b8;
    border-radius: 5px;
}
.icon {
    height: 35px;
    margin: 0 0 0 10px;
}
.partner-title {
    font-size: var(--font-size-low-medium);
    font-weight: var(--font-weight-medium);
    color: var(--color-principal);
    margin: 0;
}
.partner {
    height: 50px;
    display: flex;
    align-items: center;
}
.container-dropdown {
    border-top: solid 1px var(--medium-grey);
    position: absolute;
    height: 0;
    top: 50px;
    right: -87px;
    box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.1);
    z-index: 20;
}
.content-dropdown {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: var(--white);
    padding: 10px 20px 10px 20px;
    z-index: 3;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
    width: 10vw;
}
.dropdown-button {
    min-height: 4vh;
    border-radius: 4px;
    padding: 5px 10px;
    font-size: var(--font-size-small);
    line-height: var(--line-spacing-very-small);
    font-weight: var(--font-weight-bold);
    letter-spacing: 0.009em;
    width: 100%;
    border: none;
    cursor: pointer;
    margin-top: 10px;
}
.disconnect {
    background: var(--light-green);
    color: var(--white);
}
.options {
    color: var(--color-principal);
}
.mainContainer-nav {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
    background-color: transparent;
    height: 100vh;
    width: 100vw;
}
.login-user {
    font-weight: var(--font-weight-medium);
    font-size: var(--font-size-low-medium);
    color: var(--color-principal);
}
@media screen and (min-width: 980px) {
    .bandeau {
        padding: 0 25px 0 50px;
    }
}
.language-flags-container {
    display: flex;
    flex-direction: column;
    background-color: white;
    position: absolute;
    top: 60px;
    right: 10px;
    border-radius: 4px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
    padding: 10px;
    z-index: 20;
}

.language-flag {
    margin-bottom: 10px;
    cursor: pointer;
}

.language-flag:last-child {
    margin-bottom: 0;
}
.mainContainer-langue-nav {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
    background-color: transparent;
    height: 100vh;
    width: 100vw;
}

.bouton-avec-regle {
    position: relative;
    display: inline-flex;
    margin-right: 25px;
}
.bouton-avec-regle .bandeau-button {
    margin-right: 0;
}
.bouton-avec-regle .regle-pastille {
    position: absolute;
    top: -6px;
    right: -6px;
    margin: 0;
}

#bouton-app-info {
    background-color: v-bind(envCouleur) !important;
    color: white !important;
    border-color: v-bind(envCouleur) !important;
}

#bouton-app-info :deep(.icon) {
    filter: brightness(0) invert(1);
}

.regles-gestion-toggle {
    display: flex;
    align-items: center;
    margin-right: 25px;
    border: 1.5px solid var(--bleu-secondaire);
    border-radius: 20px;
    background-color: var(--white);
    padding: 6px 16px 6px 10px;
    font-family: inherit;
    font-weight: var(--font-weight-bold);
    font-size: var(--font-size-small);
    text-transform: uppercase;
    color: var(--bleu-secondaire);
    cursor: pointer;
    white-space: nowrap;
}
.regles-gestion-toggle__icone {
    height: 20px;
    width: 20px;
    margin-right: 8px;
}
</style>
